import React from "react";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";

const PaymentFailedPage = () => {
  return (
    <Box sx={{ textAlign: "center", margin: "100px" }}>
      <Typography>Payment Failed</Typography>
      <Link to={"/"}>Back to Home</Link>
    </Box>
  );
};

export default PaymentFailedPage;
